import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

/**
 * Dynamic help page.
 */
function SelectProfile({
  show,
  profiles = [],
  message = 'Please select the profile you want to use to sign into the adviser portal.',
  callback,
  ...props
}) {

  /**
   * Gets a list of Buttons for the provided profiles, or a loader if the list
   * is empty.
   */
  function getSelectableProfiles() {
    const mainProfileItem = {uid: '', name: 'Main profile'};
    let sanitisedProfiles = profiles;
    if (
      !Array.isArray(sanitisedProfiles) ||
      sanitisedProfiles.length === 0
    ) {
      sanitisedProfiles = [mainProfileItem];
    }
    // Check that there is a main profile.
    let foundMainProfile = false;
    for (let i = 0; i < sanitisedProfiles.length; i++) {
      foundMainProfile = foundMainProfile || sanitisedProfiles[i].uid === ''
    }
    // if there is none, add it to the front.
    if (!foundMainProfile) {
      sanitisedProfiles = [mainProfileItem, ...sanitisedProfiles];
    }

    return (
      <div className="d-grid gap-2">
      {
        sanitisedProfiles.map(profile => {
          return(
            <Button
              key={profile.uid}
              size="large"
              onClick = {() => callback(profile.uid)}
            >
              {profile.name}
            </Button>
          )
        })
      }
      </div>
    )
  }

  return (
    <Modal show={show} size="lg" onHide={ () => callback(null) }>
      <Modal.Header closeButton>
        <Modal.Title>Select profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{ message }</p>
        { getSelectableProfiles() }
      </Modal.Body>
    </Modal>
  )
}

SelectProfile.propTypes = {
  /**
   * Whether the modal should be visible or not.
   */
  show: PropTypes.bool,
  /**
   * Callback function that will be called with selected uid or null on cancel.
   */
   callback: PropTypes.func,
}

export default SelectProfile;